export function getCurrentDate() {

    let d = new Date();
    return d.getFullYear()
    +'-'
    +("0"+(d.getMonth()+1)).slice(-2)
    +'-'
    +("0"+d.getDate()).slice(-2)
}

/** Today as DD-MM-YYYY for forms that match Django %d-%m-%Y APIs */
export function getCurrentDateDisplay() {
    return formatDateForApi(getCurrentDate());
}

/** Normalize to DD-MM-YYYY for API (accepts YYYY-MM-DD or DD-MM-YYYY). */
export function formatDateForApi(dateString) {
    if (!dateString) return dateString;
    const parts = String(dateString).trim().split('-');
    if (parts.length !== 3) return dateString;
    if (parts[0].length === 4) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return dateString;
}

export function getCurrentTime() {
    let d = new Date();
    // return d.getHours() + ':' + ("0"+(d.getMinutes())).slice(-2);
    return ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
}

//Method to convert date format
export function getDisplayDate(dateString) {
console.log(dateString+"dateString")
    let dateParts = dateString.split("-");

    return dateParts[2] + "-" + dateParts[1] + "-" + dateParts[0];
}
